import { ObjectFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";
import { Col, Row } from "react-bootstrap";

function HouseFeaturesTemplate(props: ObjectFieldTemplateProps, func: any) {
  const { actionTemplate } = useUpdateSectionAction();
  return (
    <section className="cms-section">
      <h2 className="cms-section-title">{props.title} {actionTemplate} </h2>
      <div className="cms-section-content">
        <Row>
          <Col sm={8}>
            {func("main_features", props)?.content}
          </Col>
          <Col sm={4}>
            <div className="inputfile-container">
              {func("img", props)?.content}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default HouseFeaturesTemplate;
